import Form from "../form/Form";
import { edit } from '../../slices/contentTagSlice';
import { useNavigate, useParams } from "react-router-dom";
import { appUrl } from "../../utils/fetch";

function ContentTag() {
    const { id, closeFunc } = useParams();
    const navigate = useNavigate();
    
    return (
        <Form 
            inputs={{
                name: {
                    label: "Name",
                    field: "text"
                },
                color: {
                    label: "Color",
                    field: "color"
                }
            }}
            columns={2}
            stateName="contentTag"
            dispatchFunc={edit}
            title={id && id !== "new" ? "Edit Content Tag" : "Create Content Tag"}
            api={`${appUrl}/api/content-tag`}
            navbar
            detailId={id}
            doneFunc={() => { if(closeFunc){closeFunc()} else {navigate(`/settings/tags/page/1`)} }}
        />
    );
}

export default ContentTag;